'use client';
import { jsx as _jsx } from "react/jsx-runtime";
import Grid from '@enlighten/design-system/dist/Grid';
import { useTheme } from '@enlighten/design-system/dist/styles';
import useMediaQuery from '@enlighten/design-system/dist/useMediaQuery';
import Image from 'next/image';
import Slider from 'react-slick';
import CaseImage1 from '../../assets/images/zero-capital-factoring/zcf-sec-05-01-slide-01.png';
import CaseImage2 from '../../assets/images/zero-capital-factoring/zcf-sec-05-01-slide-02.png';
import CaseImage3 from '../../assets/images/zero-capital-factoring/zcf-sec-05-01-slide-03.png';
import CaseImage4 from '../../assets/images/zero-capital-factoring/zcf-sec-05-01-slide-04.png';
import CaseImage5 from '../../assets/images/zero-capital-factoring/zcf-sec-05-01-slide-05.png';
import CaseImage6 from '../../assets/images/zero-capital-factoring/zcf-sec-05-01-slide-06.png';
import CaseImage7 from '../../assets/images/zero-capital-factoring/zcf-sec-05-01-slide-07.png';
import CaseImage8 from '../../assets/images/zero-capital-factoring/zcf-sec-05-01-slide-08.png';
import CaseImage9 from '../../assets/images/zero-capital-factoring/zcf-sec-05-01-slide-09.png';
const list = [
    {
        src: CaseImage1,
        alt: `[팩토링] 경북 군위군 발전소 (188.7kW), 연 예상 매출액 : 약 4385만원`,
    },
    {
        src: CaseImage2,
        alt: `[팩토링] 경기 남양주시 발전소 (59.5kW), 연 예상 매출액 : 약 1382만원`,
    },
    {
        src: CaseImage3,
        alt: `[팩토링] 충북 음성군 발전소 (119.0kW), 연 예상 매출액 : 약 2765만원`,
    },
    {
        src: CaseImage4,
        alt: `[팩토링] 충북 음성군 발전소 (148.8kW), 연 예상 매출액 : 약 3457만원`,
    },
    {
        src: CaseImage5,
        alt: `[팩토링] 전남 광양시 발전소 (201.2kW), 연 예상 매출액 : 약 4675만원`,
    },
    {
        src: CaseImage6,
        alt: `[팩토링] 경북 상주시 발전소 (32.2kW), 연 예상 매출액 : 약 621만원`,
    },
    {
        src: CaseImage7,
        alt: `[팩토링] 경북 상주시 발전소 (99.5kW), 연 예상 매출액 : 약 2312만원`,
    },
    {
        src: CaseImage8,
        alt: `[팩토링] 경북 청주시 발전소 (99.3kW), 연 예상 매출액 : 약 2308만원`,
    },
    {
        src: CaseImage9,
        alt: `[팩토링] 경남 김해시 발전소 (120.0kW), 연 예상 매출액 : 약 2788만원`,
    },
];
// @ts-ignore
const SliderComponent = !!Slider.default ? Slider.default : Slider;
const FirstSlide = () => {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('md'));
    return (_jsx(Grid, { width: "100%", sx: {
            '.slick-list': {
                margin: { xs: '0 -20px', md: '0 -24px' },
            },
            '.slick-slide > div': {
                padding: { xs: '0 10px', md: '0 12px' },
            },
            '.slick-dots': {
                position: 'inherit',
                marginTop: 1,
                'li button:before': {
                    fontSize: 12,
                },
            },
        }, children: _jsx(SliderComponent, { slidesToShow: isMobile ? 1 : 3, infinite: false, prevArrow: null, nextArrow: null, dots: true, children: list.map((image, i) => (_jsx(Grid, { sx: {
                    outline: 'none',
                    img: {
                        maxWidth: { xs: 300, md: 448 },
                        width: '100%',
                        height: 'auto',
                        marginX: 'auto',
                    },
                }, children: process.env.NEXT_PUBLIC_IS_NEXT_JS === 'true' ||
                    process.env.NEXT_PRIVATE_IS_NEXT_JS === 'true' ? (_jsx(Image, { ...image })) : (_jsx("img", { ...image })) }, i))) }) }));
};
export default FirstSlide;
